export default () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.99023 3.37061C5.3793 3.07935 5.92826 3.16124 6.21875 3.54639H6.21973C6.5116 3.93552 6.43038 4.48622 6.04492 4.77686H6.04395C4.87955 5.6501 4.21302 6.9837 4.21289 8.43701C4.21289 10.96 6.26614 13.013 8.78906 13.0132C11.3121 13.0131 13.3652 10.9601 13.3652 8.43701C13.3651 6.98406 12.6996 5.65207 11.5352 4.77686L11.4648 4.71924C11.1366 4.41699 11.0864 3.9111 11.3584 3.54736C11.6248 3.19133 12.1062 3.09703 12.4834 3.3042H12.502L12.5908 3.37158C14.1999 4.58023 15.123 6.42896 15.123 8.43799C15.123 11.9307 12.2827 14.771 8.79004 14.771C5.29737 14.771 2.45703 11.9307 2.45703 8.43799C2.45707 6.42817 3.38151 4.58007 4.98926 3.37158L4.99023 3.37061ZM8.78906 2.229C9.27384 2.22907 9.66797 2.62312 9.66797 3.10791V7.78271C9.66797 8.2675 9.27384 8.66156 8.78906 8.66162C8.30435 8.66149 7.91016 8.26746 7.91016 7.78271V3.10791C7.91016 2.62316 8.30435 2.22914 8.78906 2.229Z"
      fill="currentColor"
    />
  </svg>
);
